class Purchase {
  static MIN_TO_BUY = 20
  static MAX_TO_BUY = 5000
}

module.exports = Purchase
